export const ADMIN = "ADMIN";